import { parseAuthToken } from './parse-app-data';
import type { BridgeOptions } from './types';
import { BRIDGE_TIMEOUT_MS } from './types';

export function readAuthToken({
	onError,
}: BridgeOptions): Promise<string | undefined> {
	const sdk = window.IxigoSDK;
	const android = window.IxiWebView;
	const ios = window.webkit?.messageHandlers?.ixigoSDK;
	if (!sdk || (!android?.loginSilently && !android?.getAuthToken && !ios)) {
		return Promise.resolve(undefined);
	}
	return new Promise((resolve) => {
		const previousSuccess = sdk.authInfo;
		const previousError = sdk.errorAuthInfo;
		let isSettled = false;
		const finish = (token?: string) => {
			if (isSettled) return;
			isSettled = true;
			clearTimeout(timer);
			if (sdk.authInfo === success) sdk.authInfo = previousSuccess;
			if (sdk.errorAuthInfo === failure) sdk.errorAuthInfo = previousError;
			resolve(token);
		};
		const success = (payload: string) => {
			if (isSettled) return;
			try {
				// Android returns a bare token; iOS sends JSON { authToken }.
				const value: unknown = payload.trim().startsWith('{')
					? JSON.parse(payload)
					: payload;
				finish(
					parseAuthToken(
						value && typeof value === 'object' && 'authToken' in value
							? value.authToken
							: value,
					),
				);
			} catch {
				onError({ stage: 'auth', reason: 'Invalid native auth response' });
				finish();
			}
		};
		const failure = () => finish();
		const timer = setTimeout(() => {
			onError({ stage: 'auth', reason: 'Native auth timed out' });
			finish();
		}, BRIDGE_TIMEOUT_MS);
		sdk.authInfo = success;
		sdk.errorAuthInfo = failure;
		try {
			const onSuccess = "javascript:window.IxigoSDK?.authInfo?.('AUTH_TOKEN')";
			const onFailure =
				"javascript:window.IxigoSDK?.errorAuthInfo?.('AUTH_TOKEN')";
			if (android?.loginSilently) android.loginSilently(onSuccess, onFailure);
			else if (android?.getAuthToken) android.getAuthToken(onSuccess);
			else
				ios?.postMessage({
					action: 'getAuthToken',
					params: {
						success:
							"javascript:window.IxigoSDK?.authInfo?.('TO_REPLACE_PAYLOAD')",
						error:
							"javascript:window.IxigoSDK?.errorAuthInfo?.('TO_REPLACE_PAYLOAD')",
						data: {},
					},
				});
		} catch {
			onError({ stage: 'auth', reason: 'Native auth bridge failed' });
			finish();
		}
	});
}
